import React from "react";
import { X } from "lucide-react";
import { getStatusBadgeStyle, getStatusText } from "../../utils/statusUtils";

const HistoryModal = ({
  theme,
  isRTL,
  t,
  language,
  showHistoryModal,
  setShowHistoryModal,
  employeeHistory,
  selectedEmployee,
  selectedEmployeeId,
}) => {
  if (!showHistoryModal) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.45)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
        direction: isRTL ? "rtl" : "ltr",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        WebkitOverflowScrolling: "touch",
      }}
      onClick={() => setShowHistoryModal(false)}
    >
      <div
        style={{
          background: theme === "dark" ? "#1e293b" : "#fff",
          borderRadius: "20px",
          width: "min(90vw, 1200px)",
          maxHeight: "85vh",
          overflowY: "auto",
          boxShadow:
            theme === "dark"
              ? "0 20px 60px rgba(0,0,0,0.6)"
              : "0 20px 60px rgba(0,0,0,0.2)",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          WebkitOverflowScrolling: "touch",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: "24px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "24px",
              flexDirection: isRTL ? "row" : "row",
              borderBottom:
                theme === "dark"
                  ? "1px solid rgba(255,255,255,0.1)"
                  : "1px solid rgba(0,0,0,0.1)",
              paddingBottom: "16px",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              WebkitOverflowScrolling: "touch",
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)'
            }}
          >
            <div>
              <h2
                style={{
                  margin: "0 0 16px 0",
                  textAlign: isRTL ? "right" : "left",
                  color: theme === "dark" ? "#fff" : "#0f172a",
                  fontSize: "24px",
                  fontWeight: "700",
                }}
              >
                {t.attendanceHistory} - {selectedEmployee} - ID: {selectedEmployeeId}
              </h2>
              {employeeHistory.length > 0 && (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "12px",
                  }}
                >
                  <div
                    style={{
                      padding: "8px 12px",
                      backgroundColor:
                        theme === "dark"
                          ? "rgba(34, 197, 94, 0.15)"
                          : "rgba(34, 197, 94, 0.1)",
                      borderRadius: "6px",
                      border:
                        theme === "dark"
                          ? "1px solid rgba(34, 197, 94, 0.3)"
                          : "1px solid rgba(34, 197, 94, 0.2)",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "11px",
                        fontWeight: "600",
                        color: theme === "dark" ? "rgba(255,255,255,0.7)" : "#666",
                        marginBottom: "2px",
                      }}
                    >
                      {t.monthlyOvertimeTotal}
                    </div>
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        color: theme === "dark" ? "rgba(34, 197, 94, 1)" : "rgb(34, 197, 94)",
                      }}
                    >
                      {employeeHistory.length > 0 && employeeHistory[0].totalOvertime
                        ? `${Math.round(employeeHistory[0].totalOvertime / 60)}h ${employeeHistory[0].totalOvertime % 60}m`
                        : "0h 0m"}
                    </div>
                  </div>
                  <div
                    style={{
                      padding: "8px 12px",
                      backgroundColor:
                        theme === "dark"
                          ? "rgba(239, 68, 68, 0.15)"
                          : "rgba(239, 68, 68, 0.1)",
                      borderRadius: "6px",
                      border:
                        theme === "dark"
                          ? "1px solid rgba(239, 68, 68, 0.3)"
                          : "1px solid rgba(239, 68, 68, 0.2)",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "11px",
                        fontWeight: "600",
                        color: theme === "dark" ? "rgba(255,255,255,0.7)" : "#666",
                        marginBottom: "2px",
                      }}
                    >
                      {t.monthlyTardinessTotal}
                    </div>
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        color: theme === "dark" ? "rgba(239, 68, 68, 1)" : "rgb(239, 68, 68)",
                      }}
                    >
                      {employeeHistory.length > 0 && employeeHistory[0].totalUndertime
                        ? `${Math.round(employeeHistory[0].totalUndertime / 60)}h ${employeeHistory[0].totalUndertime % 60}m`
                        : "0h 0m"}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <button
              onClick={() => setShowHistoryModal(false)}
              style={{
                padding: "8px",
                borderRadius: "8px",
                border: "none",
                background: "transparent",
                cursor: "pointer",
                color: theme === "dark" ? "#fff" : "#374151",
                transition: "background 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background =
                  theme === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
              }}
            >
              <X size={24} />
            </button>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "separate",
                borderSpacing: "0",
                direction: isRTL ? "rtl" : "ltr",
                minWidth: "600px",
              }}
            >
              <thead>
                <tr>
                  {[t.date, t.checkIn, t.checkOut, t.status, t.hoursWorked].map((header, i) => (
                    <th
                      key={i}
                      style={{
                        padding: "14px 16px",
                        textAlign: "center",
                        fontSize: "12px",
                        fontWeight: "700",
                        letterSpacing: "0.05em",
                        textTransform: "uppercase",
                        background:
                          theme === "dark"
                            ? "linear-gradient(135deg, rgba(55, 65, 81, 0.8), rgba(75, 85, 99, 0.8))"
                            : "linear-gradient(135deg, rgba(248, 250, 252, 0.95), rgba(241, 245, 249, 0.95))",
                        color: theme === "dark" ? "#f1f5f9" : "#1e293b",
                        borderBottom:
                          theme === "dark"
                            ? "2px solid rgba(59, 130, 246, 0.3)"
                            : "2px solid rgba(59, 130, 246, 0.1)",
                        whiteSpace: "nowrap",
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                        backdropFilter: "blur(0.625rem)",
                        boxShadow:
                          theme === "dark"
                            ? "0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.3)"
                            : "0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.1)",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {employeeHistory.map((rec, idx) => (
                  <tr
                    key={idx}
                    style={{
                      borderBottom:
                        theme === "dark"
                          ? "1px solid rgba(59, 130, 246, 0.1)"
                          : "1px solid rgba(59, 130, 246, 0.05)",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background =
                        theme === "dark"
                          ? "rgba(59, 130, 246, 0.08)"
                          : "rgba(59, 130, 246, 0.04)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "transparent";
                    }}
                  >
                    <td
                      style={{
                        padding: "14px 16px",
                        textAlign: "center",
                        fontSize: "13px",
                        color: theme === "dark" ? "rgba(255,255,255,0.85)" : "#475569",
                        borderBottom:
                          theme === "dark"
                            ? "1px solid rgba(59, 130, 246, 0.1)"
                            : "1px solid rgba(59, 130, 246, 0.05)",
                      }}
                    >
                      {new Date(rec.date).toLocaleDateString(
                        language === "ar" ? "ar-EG" : "en-US",
                        { year: "numeric", month: "long", day: "numeric" }
                      )}
                    </td>
                    <td
                      style={{
                        padding: "14px 16px",
                        textAlign: "center",
                        fontSize: "13px",
                        color: theme === "dark" ? "rgba(255,255,255,0.85)" : "#475569",
                        direction: "ltr",
                        fontFamily: "'Courier New', monospace",
                        borderBottom:
                          theme === "dark"
                            ? "1px solid rgba(59, 130, 246, 0.1)"
                            : "1px solid rgba(59, 130, 246, 0.05)",
                      }}
                    >
                      {rec.checkIn
                        ? new Date(rec.checkIn).toLocaleTimeString(
                          language === "ar" ? "ar-EG" : "en-US",
                          { hour12: false, hour: "2-digit", minute: "2-digit" }
                        )
                        : "-"}
                    </td>
                    <td
                      style={{
                        padding: "14px 16px",
                        textAlign: "center",
                        fontSize: "13px",
                        color: theme === "dark" ? "rgba(255,255,255,0.85)" : "#475569",
                        direction: "ltr",
                        fontFamily: "'Courier New', monospace",
                        borderBottom:
                          theme === "dark"
                            ? "1px solid rgba(59, 130, 246, 0.1)"
                            : "1px solid rgba(59, 130, 246, 0.05)",
                      }}
                    >
                      {rec.checkOut
                        ? new Date(rec.checkOut).toLocaleTimeString(
                          language === "ar" ? "ar-EG" : "en-US",
                          { hour12: false, hour: "2-digit", minute: "2-digit" }
                        )
                        : "-"}
                    </td>
                    <td
                      style={{
                        padding: "14px 16px",
                        textAlign: "center",
                        fontSize: "13px",
                        borderBottom:
                          theme === "dark"
                            ? "1px solid rgba(59, 130, 246, 0.1)"
                            : "1px solid rgba(59, 130, 246, 0.05)",
                      }}
                    >
                      <span style={getStatusBadgeStyle(rec.status)}>
                        {getStatusText(rec.status, language)}
                      </span>
                    </td>
                    <td
                      style={{
                        padding: "14px 16px",
                        textAlign: "center",
                        fontSize: "13px",
                        color: theme === "dark" ? "rgba(255,255,255,0.85)" : "#475569",
                        borderBottom:
                          theme === "dark"
                            ? "1px solid rgba(59, 130, 246, 0.1)"
                            : "1px solid rgba(59, 130, 246, 0.05)",
                        fontWeight: "500",
                      }}
                    >
                      {rec.workingHours
                        ? `${Math.round(parseFloat(rec.workingHours) * 10) / 10} ${language === "ar" ? "س" : "h"}`
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryModal;